export const APP_BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION || 'dev';
export const APP_BUILD_TIME = process.env.VUE_APP_BUILD_TIME || null;
export const APP_BUILD_GIT_SHA = process.env.VUE_APP_BUILD_GIT_SHA || null;

export default {
    version: APP_BUILD_VERSION,
    buildTime: APP_BUILD_TIME,
    gitSha: APP_BUILD_GIT_SHA,
};
